/* eslint-disable no-console */
import axios, { AxiosError } from "axios";
import { axiosRequestConfig, ProfileUrl } from "../apiConstants";

export interface IIsProfileValidResponse {
  isValid: boolean;
  lastNameIsValid: boolean;
  dateOfBirthIsValid: boolean;
  emailAddressIsValid: boolean;
  phoneIsValid: boolean;
  addressIsValid: boolean;
  cityIsValid: boolean;
  postalCodeIsValid: boolean;
  countryIsValid: boolean;
  message: string;
  lastName: string;
  dateOfBirth: string;
  emailAddress: string;
  phone: string;
  address: string;
  city: string;
  postalCode: string;
  country: string;
}

const getIsProfileValid = async (id: number, jwt: string) => {
  try {
    return await axios.get<IIsProfileValidResponse>(
      `${ProfileUrl}/Profile/Validation/${id}`,
      axiosRequestConfig(jwt)
    );
  } catch (err) {
    console.error(err);
    return (err as AxiosError<IIsProfileValidResponse>).response;
  }
};

export default getIsProfileValid;
